<template>
  <div class="page_banner">
    <img :src="obj.image" alt="" />
    <div class="container">
      <div class="dizhi">
        <div class="en">{{ obj.en }}</div>
        <div class="cn">{{ obj.cn }}</div>
        <div class="pos">
          <router-link :to="{ path: '/' }">HOME</router-link>
          <router-link :to="{ path: obj.link }">/{{ obj.cn }}</router-link>
        </div>
      </div>
      <div class="child" v-if="obj.list[0]?.name">
        <router-link v-for="item in obj.list" :key="item.id" :to="{ path: item.link }">{{ item.name }}</router-link>
      </div>
      <div class="childs" v-else>
        <router-link v-for="(item, index) in obj.list" :key="item.id"
          :class="{ active: cid ? cid == item.id : index == 0 }" :to="{ path: item.comp, query: { cid: item.id } }"
          @click="cid = item.id">{{ item.cat_name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    obj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cid: this.$route.query.cid,
    };
  },
};
</script>

<style lang="less" scoped>
.page_banner {
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .container {
    position: absolute;
    left: var(--containerLeft);
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .dizhi {
      background: #fff;
      border-radius: 10px 10px 0 0;
      padding: 50px 100px 20px 50px;
      color: var(--themeColor);
      margin-right: 10px;

      .cn {
        font-size: 28px;
        font-weight: 800;
        white-space: nowrap;
      }

      .pos {
        margin-top: 20px;

        a {
          color: #333;

          &:first-child {
            color: #999;
          }
        }
      }
    }

    .child {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;

      a {
        color: #fff;
        font-size: 16px;
        padding: 5px 30px;
        border-radius: 20px;
        border: 1px solid #fff;
        margin-right: 20px;
        margin-bottom: 15px;

        &.router-link-active,
        &.active {
          background: var(--themeColor2);
          border-color: var(--themeColor2);
        }
      }
    }

    .childs {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;

      a {
        white-space: nowrap;
        color: #fff;
        font-size: 16px;
        padding: 5px 15px;
        border-radius: 20px;
        border: 1px solid #fff;
        margin-right: 20px;
        margin-bottom: 15px;

        &.active {
          background: var(--themeColor2);
          border-color: var(--themeColor2);
        }
      }
    }
  }
}

@media (max-width: 1300px) {
  .page_banner {
    .container {

      .child,
      .childs {
        a {
          margin-top: 10px;
        }

        a+a {
          margin-left: 20px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .page_banner {
    height: 28vh;

    .container {
      .dizhi {
        display: none;
      }

      .child,
      .childs {
        a {
          margin-top: 10px;
        }

        a+a {
          margin-left: 20px;
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .page_banner {
    .container {

      .child,
      .childs {
        width: 100%;
        justify-content: space-between;

        a,
        a+a {
          border: none;
          margin: 0;
          padding: 3px 7px;
          border-radius: 0;
        }
      }
    }
  }
}
</style>